import { useApolloClient } from '@apollo/react-hooks';
import { useMemo } from 'react';
import { VIEWER } from '~containers/auth/gql';

export const useViewer = () => {
  const apolloClient = useApolloClient();
  return useMemo(() => apolloClient.readQuery({ query: VIEWER })?.viewer, [apolloClient]);
};

export const useUserPersonalPreference = () => {
  const apolloClient = useApolloClient();
  const viewer = apolloClient.readQuery({ query: VIEWER })?.viewer;
  return useMemo(() => viewer?.userPersonalPreference || [], [viewer?.userPersonalPreference]);
};
